var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167ae",
    d: "M18.78 3.49a.5.5 0 1 0-1 0v1.78l-.17-.18-.02-.01A8.9 8.9 0 0 0 3.27 9.74a9 9 0 0 0 4.42 10.19 8.9 8.9 0 0 0 8.47-.03.5.5 0 0 0-.48-.88A7.91 7.91 0 0 1 4.24 10a8 8 0 0 1 7.84-5.96 8 8 0 0 1 4.85 1.8l.28.27h-2.05a.5.5 0 1 0 0 1h2.62a1 1 0 0 0 1-1zm-7.3 3.01c.27 0 .5.22.5.5v5.73l2.37 2.38a.5.5 0 1 1-.7.71l-2.38-2.38a1 1 0 0 1-.3-.7V7c0-.28.23-.5.5-.5m6.37 11.05a.5.5 0 0 0 .66.75q.7-.62 1.26-1.39a.5.5 0 1 0-.8-.59q-.5.68-1.12 1.23m2.29-2.83a.5.5 0 0 1-.37-.6 8 8 0 0 0 .21-1.66.5.5 0 1 1 1 .03q-.03.94-.24 1.86a.5.5 0 0 1-.6.37m-.36-4.65a.5.5 0 1 0 .97-.24q-.21-.91-.62-1.76a.5.5 0 1 0-.9.43q.36.75.55 1.57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.b50c684254e33ce97447edd828929df6.svg";
export { ForwardRef as ReactComponent };